import React from 'react';

import { Button, Text } from '@change/ds-core-ui';
import { SparkleIcon } from '@change/ds-icons';

import { Waypoint } from '#src/app/shared/components/scroll';

export const CtaSection: React.FC<CtaSectionProps> = ({
	onCtaClick,
	onCtaView,
	headingText,
	buttonText,
	qaId,
	icon = <SparkleIcon />,
}) => {
	return (
		<div className="bg-gradient-background-dark-2">
			<Waypoint onEnter={onCtaView} />
			<div className="container flex flex-col items-center gap-13 py-20 text-center">
				<Text as="h2" variant="heading" size="large" className="text-typography-inverse-strong-fixed">
					{headingText}
				</Text>

				<Button className="w-full max-w-87.5" variant="primary" leadingIcon={icon} data-qa={qaId} onClick={onCtaClick}>
					{buttonText}
				</Button>
			</div>
		</div>
	);
};

type CtaSectionProps = {
	onCtaClick?: () => void;
	onCtaView?: () => void;
	headingText: React.ReactNode;
	buttonText: string;
	qaId?: string;
	icon?: React.ReactNode;
};
